import defColors from './Colors.scss';

const Colors = defColors;
const MapColors =  Object.fromEntries(Object.entries(Colors).map(([key, value]) => [value.toLowerCase(), key]));
const MapRgbColors =  Object.fromEntries(Object.entries(Colors).map(([key, value]) => [hexToCssRgb(value), key]));

export function findColor(colordef: string): string|null {
    let c: string|null = null;
    let i: string = colordef.toLowerCase();
    if(Colors && Colors[i]){
        c = i;
    }
    //Hex color codes
    if(!c && MapColors && MapColors[i]){
        c = MapColors[i];
    }

    //Rgb color detection
    if(!c && MapRgbColors){
        let cssRgb = hexToCssRgb(colordef);
        if(cssRgb && MapRgbColors[cssRgb]){
            c = MapRgbColors[cssRgb];
        }
    }
    return c;
}

export function hexToCssRgb(hex: string): string|null {
    let rgb: {r:number,g:number,b:number}|null = hexToRgb(hex);
    if(!rgb) return null;
    return 'rgb(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ')';
}

export function hexToRgb(hex: string): {r:number,g:number,b:number}|null  {
    // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
    let shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    hex = hex.replace(shorthandRegex, function(m, r, g, b) {
        return r + r + g + g + b + b;
    });

    let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    } : null;
}

export function findClassBgColor(colordef: string): string|null {
    let c: string|null = findColor(colordef);
    return Colors.bgClassName && c ? `${Colors.bgClassName}${c}` : null;
}

export function findClassBorderColor(colordef: string): string|null {
    let c: string|null = findColor(colordef);
    return Colors.borderClassName && c ? `${Colors.borderClassName}${c}` : null;
}

export function findClassColor(colordef: string): string|null {
    let c: string|null = findColor(colordef);
    return Colors.colorClassName && c ? `${Colors.colorClassName}${c}` : null;
}

export function mergeClass(className: Object|string,newClass: string|null): Object|null {
    if(newClass === null) {
        return null;
    }
    let clBox: Object = className instanceof Object ? className : {};
    if(className && (className instanceof String || typeof className == 'string')) {
        let list: Array<string> = className.split(' ');
        list.forEach((l) => {
            if(l){
                clBox = {...clBox,...{[l]:true}};
            }
        });
    }
    return {...clBox, ...{[newClass]:true}}
}

export function mergeBgClass(className: Object|string, colordef: string): Object|null {
    let classBgColor = findClassBgColor(colordef);
    return mergeClass(className,classBgColor);
}

export function mergeColorClass(className: Object|string, colordef: string): Object|null {
    let classColor = findClassColor(colordef);
    return mergeClass(className,classColor);
}